import imageLib from './image'

/**
 * @param file
 * @return {Promise<never>|Promise<{videoHeight: number, videoWidth: number, duration: number, objectURL: string, thumbnail:Blob }>}
 */
export function readFile (file) {
  const type = file.type.split('/')[0]
  switch (type) {
    case 'video':
      return readVideo(file)
  }
  return Promise.reject(new Error(`Unsupported File type ${file.type}`))
}

/**
 * @param {File} file
 * @return {Promise<never>|Promise<{ videoHeight:number, videoWidth:number, duration:number, objectURL:string, thumbnail:Blob }>}
 */
function readVideo (file) {
  return new Promise((resolve, reject) => {
    const objectURL = window.URL.createObjectURL(file)
    const video = document.createElement('video')
    video.addEventListener('loadeddata', async event => {
      const { videoHeight, videoWidth, duration } = event.target
      let thumbnail
      try {
        thumbnail = await imageLib.captureVideoFrame(video, duration / 2)
      } catch (e) {
        console.error(`Read file ${file.name}: ${e}`)
      }
      resolve({
        mediaHeight: videoHeight,
        mediaWidth: videoWidth,
        duration,
        objectURL,
        thumbnail
      })
    })
    video.addEventListener('error', er => {
      reject(er)
    })
    video.setAttribute('src', objectURL)
  })
}
